module.exports = __webpack_public_path__ + "img/vector.b3b57219.svg";